import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';


@Injectable({
    providedIn: 'root'
})
export class MfaService {

  constructor(
    public http: HttpClient
  ) { }

  submitToken(data){
    return this.http.post("/auth/agent/mfa-token", data)
  }
  configMfa(data){
    return this.http.post("/auth/agent/mfa-config", data)
  }
  validateConfiguration(data){
    return this.http.post("/auth/agent/mfa-config-validate", data)
  }
  sendOtpRequest(data){
    return this.http.post("/auth/agent/mfa-sendrequest", data)
  }
  verifyOtp(data){
    return this.http.post("/auth/agent/mfa-validate", data)
  }
}